import React from 'react';
import MrtDialog from './MrtDialog';

const TONES = {
  success: {
    headBg: 'rgba(34, 197, 94, 0.10)',
    headColor: '#166534',
    btnBorder: '1px solid rgba(34, 197, 94, 0.38)',
    btnBg: '#22c55e',
    btnColor: '#fff',
  },
  danger: {
    headBg: 'rgba(239,68,68,0.10)',
    headColor: 'rgba(185,28,28,0.95)',
    btnBorder: '1px solid rgba(239,68,68,0.35)',
    btnBg: 'rgba(239,68,68,0.92)',
    btnColor: '#fff',
  },
  info: {
    headBg: 'rgba(59,130,246,0.10)',
    headColor: 'rgba(29,78,216,0.98)',
    btnBorder: '1px solid rgba(59,130,246,0.30)',
    btnBg: 'rgba(59,130,246,0.92)',
    btnColor: '#fff',
  },
};

export default function MrtInfoDialog({
  open,
  ariaLabel = '안내',
  tone = 'success',
  title = '완료',
  message,
  onClose,
  zIndex,
}) {
  const t = TONES[tone] || TONES.success;

  return (
    <MrtDialog
      open={open}
      ariaLabel={ariaLabel}
      onClose={onClose}
      zIndex={zIndex}
      panelStyle={{ width: 'min(460px, 92vw)' }}
    >
      <div style={{ padding: '12px 14px', background: t.headBg, color: t.headColor, fontWeight: 950 }}>
        {title}
      </div>
      <div style={{ padding: '12px 14px', fontSize: '13px', color: 'var(--mrt-text)', fontWeight: 650, lineHeight: 1.45 }}>
        {String(message || '')}
      </div>
      <div style={{ padding: '12px 14px', display: 'flex', justifyContent: 'flex-end' }}>
        <button
          type="button"
          onClick={() => onClose?.()}
          style={{
            height: '36px',
            padding: '0 12px',
            borderRadius: '12px',
            border: t.btnBorder,
            background: t.btnBg,
            color: t.btnColor,
            fontWeight: 950,
            cursor: 'pointer',
          }}
        >
          확인
        </button>
      </div>
    </MrtDialog>
  );
}












